import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const services = [{
    name: 'NEMT',
    href: '/services'
  }, {
    name: 'Wheelchair Transport',
    href: '/services'
  }, {
    name: 'Stretcher Transport',
    href: '/services'
  }, {
    name: 'Ambulatory Transport',
    href: '/services'
  }];
  return <nav className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white'}`} data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-179">
        <div className="flex justify-between items-center" data-id="element-180">
          {/* Logo */}
          <div className="flex items-center" data-id="element-181">
            <a href="/" className="text-2xl font-bold text-[#0B1F3A]" data-id="element-182">
              Judah Medical Transport
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-183">
            <a href="/" className="text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-184">
              Home
            </a>
            <a href="/about" className="text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-185">
              About Us
            </a>
            <div className="relative group" data-id="element-186">
              <button className="flex items-center text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-187">
                Services
                <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-188" />
              </button>
              <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200" data-id="element-189">
                {services.map(service => <a key={service.name} href={service.href} className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#E63946] transition-colors first:rounded-t-lg last:rounded-b-lg" data-id="element-190">
                    {service.name}
                  </a>)}
              </div>
            </div>
            <a href="/service-areas" className="text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-191">
              Service Areas
            </a>
            <a href="/blog" className="text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-192">
              Blog
            </a>
            <a href="/contact" className="text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-193">
              Contact
            </a>
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block" data-id="element-194">
            <Button variant="primary" onClick={() => window.location.href = '/#hero'} data-id="element-195">
              Book a Ride
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-gray-700 hover:text-[#E63946] transition-colors" aria-label="Toggle menu" data-id="element-196">
            {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-197" /> : <MenuIcon className="h-6 w-6" data-id="element-198" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="lg:hidden mt-4 pb-4 border-t border-gray-200" data-id="element-199">
            <div className="flex flex-col space-y-4 mt-4" data-id="element-200">
              <a href="/" className="text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-201">
                Home
              </a>
              <a href="/about" className="text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-202">
                About Us
              </a>
              <div data-id="element-203">
                <button onClick={() => setIsServicesOpen(!isServicesOpen)} className="flex items-center text-gray-700 hover:text-[#E63946] transition-colors font-medium w-full" data-id="element-204">
                  Services
                  <ChevronDownIcon className={`ml-1 h-4 w-4 transition-transform ${isServicesOpen ? 'rotate-180' : ''}`} data-id="element-205" />
                </button>
                {isServicesOpen && <div className="ml-4 mt-2 space-y-2" data-id="element-206">
                    {services.map(service => <a key={service.name} href={service.href} className="block text-gray-600 hover:text-[#E63946] transition-colors" data-id="element-207">
                        {service.name}
                      </a>)}
                  </div>}
              </div>
              <a href="/service-areas" className="text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-208">
                Service Areas
              </a>
              <a href="/blog" className="text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-209">
                Blog
              </a>
              <a href="/contact" className="text-gray-700 hover:text-[#E63946] transition-colors font-medium" data-id="element-210">
                Contact
              </a>
              <Button variant="primary" className="w-full" onClick={() => window.location.href = '/#hero'} data-id="element-211">
                Book a Ride
              </Button>
            </div>
          </div>}
      </div>
    </nav>;
}